export const PaymentLabel = [
    {
        fileName: 'merchant_id',
        title: 'Merchant ID'
    },
    {
        fileName: 'hash_value',
        title: 'Hash Value'
    },
    {
        fileName: 'access_code',
        title: 'Access Code'
    },
    {
        fileName: 'id',
        title: 'PayGate ID'
    },
    {
        fileName: 'pass',
        title: 'Paygate password'
    },
    {
        fileName: 'auth_token',
        title: 'Auth Token'
    },
    {
        fileName: 'channel_id',
        title: 'Channel ID'
    },
    {
        fileName: 'key',
        title: 'Publish Key'
    },
    {
        fileName: 'secret_key',
        title: 'Secret Key'
    },
    {
        fileName: 'service_type',
        title: 'Service Type'
    },
    {
        fileName: 'service_description',
        title: 'Service Description'
    },
    {
        fileName: 'company_token',
        title: 'Company Token'
    },
    {
        fileName: 'client_id',
        title: 'Client ID'
    },
    {
        fileName: 'client_secret',
        title: 'Client Secret'
    },
    {
        fileName: 'entity_id',
        title: 'Entity ID'
    },
    {
        fileName: 'webhook_secret',
        title: 'Webhook Secret'
    },
]

export const WIDGET_FIELD_MAX_LENGTH = 20;
export const WIDGET_DESCRIPTION_MAX_LENGTH = 100;

export const REQUIRED_FIELDS_FOR_CRDB_AND_DPO_PAYMENTS = 3;
export const REQUIRED_FIELDS_FOR_OTHER_PAYMENTS = 2;
export const REQUIRED_FIELDS_FOR_MOBIPAID_PAYMENTS = 3;
export const REQUIRED_FIELDS_FOR_PEACH_V2_PAYMENTS = 5;
